/*
  テクノロジー詳細の左カラム（続けて並ぶところの入れ替え）
  sections/custom-tech-detail.liquid

  編集はGit経由で行ってください（管理画面から直接編集しないでください）

  実装仕様
  #1 詳細セクションが続けて並ぶところを「組」にまとめる。組の中では次の技術へ
     移るとき、左カラムを上下に動かさず同じ位置でフェードで入れ替える
     （2026-09-24 PM指示）。前後に詳細が無い1本は組にしない（従来どおり）
  #2 ここでするのは印を付けることだけ。組のどこにいるか（data c tech joined の
     prev / next）と、今の1本（data c tech current）。動かさない仕掛けも
     フェードも CSS 側にある（assets/custom tech detail.css）
  #3 今の1本は「上端が画面の中央を越えた最後のセクション」。HISTORYの年表と同じく
     画面の中央で決める。組より上にいるあいだは先頭、組を過ぎたら最後尾のまま。
     組の入りと出は普通のスクロールになる
  #3b スクロールしていなくても、セクションの高さが変われば測り直す。
     画像の読み込みで上のセクションが伸びると、画面の中央に来ている1本が
     スクロールイベント無しで入れ替わる
  #4 印を付け直すときはフェードさせない。読み込み直後や組み直しで、
     今の1本でない側がゆっくり消えていく途中を見せないため
  #5 JSが読めないときは印が付かないので、セクションごとに貼り付く（従来どおり）
  #6 テーマエディタでの追加・削除・並べ替えで組み直す
  #7 このファイルはセクションの数だけ読み込まれる（7本なら7回）。
     2回目以降は何もしない
*/
(function () {
  'use strict';

  /* 実装仕様 #7 */
  if (window.cTechDetail) {
    return;
  }

  window.cTechDetail = true;

  var SELECTOR = '[data-c-tech-detail]';
  var JOINED = 'data-c-tech-joined';
  var CURRENT = 'data-c-tech-current';

  var groups = [];
  var queued = false;
  var resizer = null;

  function details() {
    return Array.prototype.slice.call(document.querySelectorAll(SELECTOR));
  }

  /* セクションの外枠。隣り合っているかはこの兄弟関係で見る */
  function wrapperOf(detail) {
    return detail.closest('.shopify-section') || detail;
  }

  /* 実装仕様 #3 */
  function update() {
    queued = false;

    var line = window.innerHeight / 2;

    groups.forEach(function (group) {
      var current = 0;

      group.forEach(function (detail, index) {
        if (detail.getBoundingClientRect().top <= line) {
          current = index;
        }
      });

      group.forEach(function (detail, index) {
        detail.toggleAttribute(CURRENT, index === current);
      });
    });
  }

  function queue() {
    if (queued) {
      return;
    }

    queued = true;
    window.requestAnimationFrame(update);
  }

  /* 実装仕様 #1 #4 */
  function build() {
    var all = details();
    var asides = all.map(function (detail) {
      return detail.querySelector('.c-tech-detail__aside');
    }).filter(Boolean);

    asides.forEach(function (aside) {
      aside.style.transition = 'none';
    });

    all.forEach(function (detail) {
      detail.removeAttribute(JOINED);
      detail.removeAttribute(CURRENT);
    });

    groups = [];

    var run = [];

    all.forEach(function (detail) {
      var last = run[run.length - 1];

      if (last && wrapperOf(last).nextElementSibling === wrapperOf(detail)) {
        run.push(detail);
        return;
      }

      if (run.length > 1) {
        groups.push(run);
      }

      run = [detail];
    });

    if (run.length > 1) {
      groups.push(run);
    }

    /* 実装仕様 #3b */
    if (resizer) {
      resizer.disconnect();
    }

    if ('ResizeObserver' in window) {
      resizer = new ResizeObserver(queue);
    }

    groups.forEach(function (group) {
      group.forEach(function (detail, index) {
        var joined = [];

        if (resizer) {
          resizer.observe(detail);
        }

        if (index > 0) {
          joined.push('prev');
        }

        if (index < group.length - 1) {
          joined.push('next');
        }

        detail.setAttribute(JOINED, joined.join(' '));
      });
    });

    update();

    /*
      印を付けた状態をフェードなしのまま確定させてから、フェードを戻す。
      確定させずに戻すと、次のフレームで「フェードあり」として計算される
    */
    document.body.getBoundingClientRect();

    window.requestAnimationFrame(function () {
      asides.forEach(function (aside) {
        aside.style.transition = '';
      });
    });
  }

  window.addEventListener('scroll', queue, { passive: true });
  window.addEventListener('resize', queue);

  /*
    実装仕様 #6。unload はセクションがまだ残っているうちに来るので、
    1フレーム待ってから組み直す
  */
  ['shopify:section:load', 'shopify:section:unload', 'shopify:section:reorder'].forEach(function (name) {
    document.addEventListener(name, function () {
      window.requestAnimationFrame(build);
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', build);
  } else {
    build();
  }
})();
